module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('figure', {
    staticClass: "avatar avatar-sm",
    attrs: {
      "data-initial": _vm.inits
    }
  }, [(_vm.avatar) ? _c('img', {
    attrs: {
      "src": _vm.avatar
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07686c12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/avatar.vue
// module id = 474
// module chunks = 1